import { render, staticRenderFns } from "./VersionActivity.vue?vue&type=template&id=5014d085&scoped=true"
import script from "./VersionActivity.vue?vue&type=script&lang=js"
export * from "./VersionActivity.vue?vue&type=script&lang=js"
import style0 from "./VersionActivity.vue?vue&type=style&index=0&id=5014d085&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5014d085",
  null
  
)

export default component.exports